import React from 'react';
import { IconProps } from '../IconProps';


export const Nl: React.FC<IconProps> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" width={props.width} height={props.height} version="1" y="0" x="0" className={props.className}>
            <g id="flag" fillRule="evenodd" strokeWidth="1pt" transform="scale(1.25 .9375)">
                <rect id="rect171" rx="0" ry="0" height="509.76" width="512" y="-.0000019907" x="0" fill="#fff"/>
                <rect id="rect256" rx="0" ry="0" height="169.92" width="512" y="342.08" x="0" fill="#21468b"/>
                <rect id="rect255" height="169.92" width="512" y="-.0000019907" x="0" fill="#ae1c28"/>
            </g>
        </svg>
    )
};
